/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../common/glyph/glyph_icon';
import '../../common/component/component';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "dashboard": {
            "nested": {
              "instant_access": {
                "nested": {
                  "InstantAccessError": {
                    "values": {
                      "INSTANT_ACCESS_ERROR_DO_NOT_USE": 0,
                      "GENERIC_INSTANT_ACCESS_ERROR": 1
                    }
                  },
                  "InstantAccessRequirementItem": {
                    "fields": {
                      "type": {
                        "type": "squareup.bbfrontend.dashboard.instant_access.InstantAccessRequirementItem.Type",
                        "id": 1,
                        "rule": "optional"
                      },
                      "isCompleted": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      },
                      "icon": {
                        "type": "squareup.bbfrontend.common.glyph.GlyphIcon",
                        "id": 3,
                        "rule": "optional"
                      },
                      "label": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "subtext": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "isDisabled": {
                        "type": "bool",
                        "id": 8,
                        "rule": "optional"
                      },
                      "tooltip": {
                        "type": "squareup.bbfrontend.dashboard.instant_access.InstantAccessRequirementItem.Tooltip",
                        "id": 9,
                        "rule": "optional"
                      },
                      "directUrl": {
                        "type": "squareup.bbfrontend.common.component.WebURL",
                        "id": 6
                      },
                      "inAppFlow": {
                        "type": "squareup.bbfrontend.dashboard.instant_access.InstantAccessRequirementItem.InAppFlow",
                        "id": 7
                      }
                    },
                    "nested": {
                      "InAppFlow": {
                        "values": {
                          "INSTANT_ACCESS_REQUIREMENT_ITEM_IN_APP_FLOW_DO_NOT_USE": 0,
                          "CHECKING_ONBOARDING": 1,
                          "CHECKING_ACCOUNT_NUMBERS_MODAL": 2
                        }
                      },
                      "Type": {
                        "values": {
                          "INSTANT_ACCESS_REQUIREMENT_ITEM_TYPE_DO_NOT_USE": 0,
                          "ACTIVE_CHECKING_ACCOUNT": 1,
                          "DIRECT_DEPOSITS_SETUP": 2,
                          "ORDERS_INTEGRATION_SETUP": 3
                        }
                      },
                      "Tooltip": {
                        "fields": {
                          "icon": {
                            "type": "squareup.bbfrontend.common.glyph.GlyphIcon",
                            "id": 1,
                            "rule": "optional"
                          },
                          "text": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "action": {
                        "oneof": ["directUrl", "inAppFlow"]
                      }
                    }
                  },
                  "InstantAccessAccordionItem": {
                    "fields": {
                      "platformLabel": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "logoImageUrl": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "logoImageBackgroundColorCode": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "pillDescription": {
                        "type": "squareup.bbfrontend.common.component.PillDescription",
                        "id": 4,
                        "rule": "optional"
                      },
                      "requirementItems": {
                        "type": "squareup.bbfrontend.dashboard.instant_access.InstantAccessRequirementItem",
                        "id": 5,
                        "rule": "repeated"
                      },
                      "isDisabled": {
                        "type": "bool",
                        "id": 6,
                        "rule": "optional"
                      }
                    }
                  },
                  "OnboardInstantAccessForRSTRequest": {
                    "fields": {
                      "unitToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "OnboardInstantAccessForRSTResponse": {
                    "fields": {
                      "success": {
                        "type": "squareup.bbfrontend.dashboard.instant_access.OnboardInstantAccessForRSTResponse.Success",
                        "id": 1
                      },
                      "failure": {
                        "type": "squareup.bbfrontend.dashboard.instant_access.OnboardInstantAccessForRSTResponse.Failure",
                        "id": 2
                      }
                    },
                    "nested": {
                      "Success": {
                        "fields": {}
                      },
                      "Failure": {
                        "fields": {
                          "errors": {
                            "type": "squareup.bbfrontend.dashboard.instant_access.InstantAccessError",
                            "id": 1,
                            "rule": "repeated"
                          }
                        }
                      },
                      "result": {
                        "oneof": ["success", "failure"]
                      }
                    }
                  },
                  "RetrieveInstantAccessRequirementsStateForRSTRequest": {
                    "fields": {
                      "unitToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "RetrieveInstantAccessRequirementsStateForRSTResponse": {
                    "fields": {
                      "success": {
                        "type": "squareup.bbfrontend.dashboard.instant_access.RetrieveInstantAccessRequirementsStateForRSTResponse.Success",
                        "id": 1
                      },
                      "failure": {
                        "type": "squareup.bbfrontend.dashboard.instant_access.RetrieveInstantAccessRequirementsStateForRSTResponse.Failure",
                        "id": 2
                      }
                    },
                    "nested": {
                      "Success": {
                        "fields": {
                          "accordionItems": {
                            "type": "squareup.bbfrontend.dashboard.instant_access.InstantAccessAccordionItem",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "optedIn": {
                            "type": "bool",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "Failure": {
                        "fields": {
                          "errors": {
                            "type": "squareup.bbfrontend.dashboard.instant_access.InstantAccessError",
                            "id": 1,
                            "rule": "repeated"
                          }
                        }
                      },
                      "result": {
                        "oneof": ["success", "failure"]
                      }
                    }
                  },
                  "RequestPinwheelLinkTokenRequest": {
                    "fields": {
                      "unitToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "RequestPinwheelLinkTokenResponse": {
                    "fields": {
                      "success": {
                        "type": "squareup.bbfrontend.dashboard.instant_access.RequestPinwheelLinkTokenResponse.Success",
                        "id": 1
                      },
                      "failure": {
                        "type": "squareup.bbfrontend.dashboard.instant_access.RequestPinwheelLinkTokenResponse.Failure",
                        "id": 2
                      }
                    },
                    "nested": {
                      "Success": {
                        "fields": {
                          "linkToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "Failure": {
                        "fields": {
                          "errors": {
                            "type": "squareup.bbfrontend.dashboard.instant_access.InstantAccessError",
                            "id": 1,
                            "rule": "repeated"
                          }
                        }
                      },
                      "result": {
                        "oneof": ["success", "failure"]
                      }
                    }
                  },
                  "DashboardWebInstantAccessService": {
                    "methods": {
                      "OnboardInstantAccessForRST": {
                        "requestType": "squareup.bbfrontend.dashboard.instant_access.OnboardInstantAccessForRSTRequest",
                        "responseType": "squareup.bbfrontend.dashboard.instant_access.OnboardInstantAccessForRSTResponse"
                      },
                      "RetrieveInstantAccessRequirementsStateForRST": {
                        "requestType": "squareup.bbfrontend.dashboard.instant_access.RetrieveInstantAccessRequirementsStateForRSTRequest",
                        "responseType": "squareup.bbfrontend.dashboard.instant_access.RetrieveInstantAccessRequirementsStateForRSTResponse"
                      },
                      "RequestPinwheelLinkToken": {
                        "requestType": "squareup.bbfrontend.dashboard.instant_access.RequestPinwheelLinkTokenRequest",
                        "responseType": "squareup.bbfrontend.dashboard.instant_access.RequestPinwheelLinkTokenResponse"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.instant_access?.nested?.InstantAccessError && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.instant_access?.nested?.InstantAccessRequirementItem && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.instant_access?.nested?.InstantAccessRequirementItem?.nested?.InAppFlow && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.instant_access?.nested?.InstantAccessRequirementItem?.nested?.Type && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.instant_access?.nested?.InstantAccessRequirementItem?.nested?.Tooltip && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.instant_access?.nested?.InstantAccessAccordionItem && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.instant_access?.nested?.OnboardInstantAccessForRSTRequest && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.instant_access?.nested?.OnboardInstantAccessForRSTResponse && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.instant_access?.nested?.OnboardInstantAccessForRSTResponse?.nested?.Success && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.instant_access?.nested?.OnboardInstantAccessForRSTResponse?.nested?.Failure && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.instant_access?.nested?.RetrieveInstantAccessRequirementsStateForRSTRequest && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.instant_access?.nested?.RetrieveInstantAccessRequirementsStateForRSTResponse && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.instant_access?.nested?.RetrieveInstantAccessRequirementsStateForRSTResponse?.nested?.Success && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.instant_access?.nested?.RetrieveInstantAccessRequirementsStateForRSTResponse?.nested?.Failure && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.instant_access?.nested?.RequestPinwheelLinkTokenRequest && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.instant_access?.nested?.RequestPinwheelLinkTokenResponse && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.instant_access?.nested?.RequestPinwheelLinkTokenResponse?.nested?.Success && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.instant_access?.nested?.RequestPinwheelLinkTokenResponse?.nested?.Failure && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.instant_access?.nested?.DashboardWebInstantAccessService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE InstantAccessError @ squareup/bbfrontend/dashboardweb/instant_access/instant_access_service.proto at 15:1
 */
export const InstantAccessError = $root.lookupEnum('squareup.bbfrontend.dashboard.instant_access.InstantAccessError').values;
/**
 * SOURCE InstantAccessRequirementItem @ squareup/bbfrontend/dashboardweb/instant_access/instant_access_service.proto at 20:1
 */
export const InstantAccessRequirementItem = $root.lookupType('squareup.bbfrontend.dashboard.instant_access.InstantAccessRequirementItem');
fixType(InstantAccessRequirementItem, {
  type: {
    required: true
  },
  isCompleted: {
    required: true
  }
});
Builder.createAndAttachToType(InstantAccessRequirementItem);
/**
 * SOURCE InAppFlow @ squareup/bbfrontend/dashboardweb/instant_access/instant_access_service.proto at 21:3
 */
InstantAccessRequirementItem.InAppFlow = $root.lookupEnum('squareup.bbfrontend.dashboard.instant_access.InstantAccessRequirementItem.InAppFlow').values;
/**
 * SOURCE Type @ squareup/bbfrontend/dashboardweb/instant_access/instant_access_service.proto at 26:3
 */
InstantAccessRequirementItem.Type = $root.lookupEnum('squareup.bbfrontend.dashboard.instant_access.InstantAccessRequirementItem.Type').values;
/**
 * SOURCE Tooltip @ squareup/bbfrontend/dashboardweb/instant_access/instant_access_service.proto at 33:3
 */
InstantAccessRequirementItem.Tooltip = $root.lookupType('squareup.bbfrontend.dashboard.instant_access.InstantAccessRequirementItem.Tooltip');
fixType(InstantAccessRequirementItem.Tooltip);
Builder.createAndAttachToType(InstantAccessRequirementItem.Tooltip);
/**
 * SOURCE InstantAccessAccordionItem @ squareup/bbfrontend/dashboardweb/instant_access/instant_access_service.proto at 51:1
 */
export const InstantAccessAccordionItem = $root.lookupType('squareup.bbfrontend.dashboard.instant_access.InstantAccessAccordionItem');
fixType(InstantAccessAccordionItem);
Builder.createAndAttachToType(InstantAccessAccordionItem);
/**
 * SOURCE OnboardInstantAccessForRSTRequest @ squareup/bbfrontend/dashboardweb/instant_access/instant_access_service.proto at 60:1
 */
export const OnboardInstantAccessForRSTRequest = $root.lookupType('squareup.bbfrontend.dashboard.instant_access.OnboardInstantAccessForRSTRequest');
fixType(OnboardInstantAccessForRSTRequest, {
  unitToken: {
    required: true
  }
});
Builder.createAndAttachToType(OnboardInstantAccessForRSTRequest);
/**
 * SOURCE OnboardInstantAccessForRSTResponse @ squareup/bbfrontend/dashboardweb/instant_access/instant_access_service.proto at 64:1
 */
export const OnboardInstantAccessForRSTResponse = $root.lookupType('squareup.bbfrontend.dashboard.instant_access.OnboardInstantAccessForRSTResponse');
fixType(OnboardInstantAccessForRSTResponse);
Builder.createAndAttachToType(OnboardInstantAccessForRSTResponse);
/**
 * SOURCE Success @ squareup/bbfrontend/dashboardweb/instant_access/instant_access_service.proto at 70:3
 */
OnboardInstantAccessForRSTResponse.Success = $root.lookupType('squareup.bbfrontend.dashboard.instant_access.OnboardInstantAccessForRSTResponse.Success');
fixType(OnboardInstantAccessForRSTResponse.Success);
Builder.createAndAttachToType(OnboardInstantAccessForRSTResponse.Success);
/**
 * SOURCE Failure @ squareup/bbfrontend/dashboardweb/instant_access/instant_access_service.proto at 72:3
 */
OnboardInstantAccessForRSTResponse.Failure = $root.lookupType('squareup.bbfrontend.dashboard.instant_access.OnboardInstantAccessForRSTResponse.Failure');
fixType(OnboardInstantAccessForRSTResponse.Failure);
Builder.createAndAttachToType(OnboardInstantAccessForRSTResponse.Failure);
/**
 * SOURCE RetrieveInstantAccessRequirementsStateForRSTRequest @ squareup/bbfrontend/dashboardweb/instant_access/instant_access_service.proto at 77:1
 */
export const RetrieveInstantAccessRequirementsStateForRSTRequest = $root.lookupType('squareup.bbfrontend.dashboard.instant_access.RetrieveInstantAccessRequirementsStateForRSTRequest');
fixType(RetrieveInstantAccessRequirementsStateForRSTRequest, {
  unitToken: {
    required: true
  }
});
Builder.createAndAttachToType(RetrieveInstantAccessRequirementsStateForRSTRequest);
/**
 * SOURCE RetrieveInstantAccessRequirementsStateForRSTResponse @ squareup/bbfrontend/dashboardweb/instant_access/instant_access_service.proto at 81:1
 */
export const RetrieveInstantAccessRequirementsStateForRSTResponse = $root.lookupType('squareup.bbfrontend.dashboard.instant_access.RetrieveInstantAccessRequirementsStateForRSTResponse');
fixType(RetrieveInstantAccessRequirementsStateForRSTResponse);
Builder.createAndAttachToType(RetrieveInstantAccessRequirementsStateForRSTResponse);
/**
 * SOURCE Success @ squareup/bbfrontend/dashboardweb/instant_access/instant_access_service.proto at 87:3
 */
RetrieveInstantAccessRequirementsStateForRSTResponse.Success = $root.lookupType('squareup.bbfrontend.dashboard.instant_access.RetrieveInstantAccessRequirementsStateForRSTResponse.Success');
fixType(RetrieveInstantAccessRequirementsStateForRSTResponse.Success);
Builder.createAndAttachToType(RetrieveInstantAccessRequirementsStateForRSTResponse.Success);
/**
 * SOURCE Failure @ squareup/bbfrontend/dashboardweb/instant_access/instant_access_service.proto at 92:3
 */
RetrieveInstantAccessRequirementsStateForRSTResponse.Failure = $root.lookupType('squareup.bbfrontend.dashboard.instant_access.RetrieveInstantAccessRequirementsStateForRSTResponse.Failure');
fixType(RetrieveInstantAccessRequirementsStateForRSTResponse.Failure);
Builder.createAndAttachToType(RetrieveInstantAccessRequirementsStateForRSTResponse.Failure);
/**
 * SOURCE RequestPinwheelLinkTokenRequest @ squareup/bbfrontend/dashboardweb/instant_access/instant_access_service.proto at 97:1
 */
export const RequestPinwheelLinkTokenRequest = $root.lookupType('squareup.bbfrontend.dashboard.instant_access.RequestPinwheelLinkTokenRequest');
fixType(RequestPinwheelLinkTokenRequest, {
  unitToken: {
    required: true
  }
});
Builder.createAndAttachToType(RequestPinwheelLinkTokenRequest);
/**
 * SOURCE RequestPinwheelLinkTokenResponse @ squareup/bbfrontend/dashboardweb/instant_access/instant_access_service.proto at 101:1
 */
export const RequestPinwheelLinkTokenResponse = $root.lookupType('squareup.bbfrontend.dashboard.instant_access.RequestPinwheelLinkTokenResponse');
fixType(RequestPinwheelLinkTokenResponse);
Builder.createAndAttachToType(RequestPinwheelLinkTokenResponse);
/**
 * SOURCE Success @ squareup/bbfrontend/dashboardweb/instant_access/instant_access_service.proto at 107:3
 */
RequestPinwheelLinkTokenResponse.Success = $root.lookupType('squareup.bbfrontend.dashboard.instant_access.RequestPinwheelLinkTokenResponse.Success');
fixType(RequestPinwheelLinkTokenResponse.Success);
Builder.createAndAttachToType(RequestPinwheelLinkTokenResponse.Success);
/**
 * SOURCE Failure @ squareup/bbfrontend/dashboardweb/instant_access/instant_access_service.proto at 111:3
 */
RequestPinwheelLinkTokenResponse.Failure = $root.lookupType('squareup.bbfrontend.dashboard.instant_access.RequestPinwheelLinkTokenResponse.Failure');
fixType(RequestPinwheelLinkTokenResponse.Failure);
Builder.createAndAttachToType(RequestPinwheelLinkTokenResponse.Failure);
/**
 * SOURCE DashboardWebInstantAccessService @ squareup/bbfrontend/dashboardweb/instant_access/instant_access_service.proto at 116:1
 */
export const DashboardWebInstantAccessService = $root.lookupService('squareup.bbfrontend.dashboard.instant_access.DashboardWebInstantAccessService');